import React from 'react';
import { Select } from 'antd';
import { FieldProps } from '../../../../../components/Form/fields';
import useCollection from '../../../../../hooks/useCollection';
import { Language } from '../../../../../models/Language';
import { getValueInCurrentLanguage } from '../../../../../helpers/getValueInLanguage';

export const LanguageField: React.ComponentType<FieldProps<string>> = ({
  value,
  onChange,
  readonly,
  errors,
}) => {
  const [items] = useCollection(Language);
  const options = items.map((language) => ({
    value: language.id,
    label: getValueInCurrentLanguage(language.language),
  }));

  const fieldErrors = errors.filter((err) => err.path?.match(/^[a-zA-Z]*$/));

  return (
    <>
      <Select
        style={{ width: '100%' }}
        disabled={readonly}
        value={value}
        onChange={onChange}
      >
        {options.map((option) => (
          <Select.Option value={option.value} key={option.value}>
            <span>{option.label}</span>
          </Select.Option>
        ))}
      </Select>
      {!readonly && fieldErrors.length > 0 && (
        <div className="form--error">
          {fieldErrors.map((err) => err.message).join('. ')}
        </div>
      )}
    </>
  );
};

export default LanguageField;
